<template>
  <b-row>
    <b-col lg="12">
      <b-card>
        <div class="card-body">
          <img id="post-img" :src="content.thumbnail" :alt="content.title"/>
          <div class="mt-5">
            <span
            ><b-icon icon="person-fill"/>&MediumSpace;&MediumSpace; نویسنده :
              <span v-if="content.author">{{
                  `${content.author.name} ${content.author.last_name}`
                }}</span> </span
            >/&MediumSpace;
            <span
            ><b-icon icon="calendar2-minus"/>&MediumSpace;&MediumSpace;تاریخ
              و ساعت:

              <span>{{ getPostDate(content.created_at) }}</span>
            </span>
          </div>

          <div class="">
            <span>دسته بندی ها:</span>
            <m-a class=" rounded-pill mr-1" v-for="(category,index) in content.category" :key="index"
                 :href="{name:'Posts',query:{category:category.slug}}">
              <small>{{ category.name }} </small>
            </m-a>
          </div>

          <h4 class="card-title">{{ content.title }}</h4>

          <div v-html="processContent(content.body)" class="card-text"></div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  convertToJalaliWithTime,
  dateConverter,
} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {mapGetters} from 'vuex'

export default {
  name: "SinglePost1",
  data() {
    return {
      date: "",
      hour: "",
      courseSlug: this.$route.params.courseSlug,
    };
  },
  methods: {
    getPostDate(date) {
      return convertToJalaliWithTime(date, "/");
    },
  },
  computed: {
    ...mapGetters({
      content: "Content/getContent"
    })
  },
  mounted() {
    this.$store.dispatch("Content/getContent", this.$route.params.slug)
  }
};
</script>

<style scoped>
.card {
  margin: 15px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.14);
}

.card-body {
  padding: 7px;
}

.card-title {
  margin-top: 30px;
}

hr {
  background-color: #707070;
  color: #707070;
  width: 90%;
  display: flex;
  align-self: center;
}

.card-text {
  margin-top: 50px;
  text-align: right;
}

span {
  font-size: 12px;
}

p {
  font-size: 14px;
}

#post-img,
#page-img,
#lesson-img {
  width: 100%;
  max-height: 600px;
  border-radius: 4px;
  object-fit: cover;
}

#to-course {
  background-color: #212967;
  color: orange;
}

.video-wrapper {
  display: none !important;
}
</style>